if(!global["bf"]) global["bf"] = {};
module.exports = global["bf"]["createCalendarBrowser"] = require("-!/builds/360psg/blank/savannah/node_modules/babel-loader/lib/index.js??ref--0!/builds/360psg/blank/savannah/src/frontend/calendar.js").default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-default-loader?bf.createCalendarBrowser!./src/frontend/calendar.js
// module id = 284
// module chunks = 4